import { ExternalBankAccount } from "@wingspanhq/wingspan-api-sdk";

export const selectorExternalBankAccountName = (
  externalBankAccount: ExternalBankAccount,
  options?: {
    specifyEmptyMask?: boolean;
  }
) => {
  const type =
    externalBankAccount.accountType || externalBankAccount.accountName;
  const last4 = externalBankAccount.accountNumberMask;

  if (!type) {
    return externalBankAccount.accountName;
  }

  if (!last4) {
    return options?.specifyEmptyMask ? `${type} (n/a)` : type;
  }

  return `${type} (${last4})`;
};
